export default __webpack_public_path__ + "static/media/app.9bb7490b.mp4";